import React from 'react';
import CheckBoxOutlineBlankOutlined from '@material-ui/icons/CheckBoxOutlineBlankOutlined';

export default function CheckBoxOutlineBlankOutlinedIcon() {

    return (
        <CheckBoxOutlineBlankOutlined />
    );
}
